import { useTranslation } from 'react-i18next'

import { Alert, AlertTitle } from '@mui/material'

import { format } from 'date-fns'

import CurrencyUtils from '@utils/currency'
import type { IPromotionCode } from '@utils/types'

import { checkoutAlertSx } from './styles'

export interface IPromotionCodeAlertProps {
  promotionCode: IPromotionCode
  variant?: 'signup' | 'checkout'
}

const PromotionCodeAlert = ({
  promotionCode,
  variant = 'signup',
}: IPromotionCodeAlertProps) => {
  const { t } = useTranslation()

  const hasExpirationDate = !!promotionCode.expirationDate

  if (variant === 'signup') {
    return (
      <Alert severity="success" data-testid="promotion-code-alert">
        <AlertTitle>
          {t('{{name}} offer available{{exclamation}}', {
            name: promotionCode.name,
            exclamation: !hasExpirationDate ? '!' : '',
          })}
          {hasExpirationDate &&
            ` until ${format(promotionCode.expirationDate!, 'LLL dd yyyy')}!`}
        </AlertTitle>
        {t(
          'Sign up now and receive an exclusive discount on your subscription'
        )}
      </Alert>
    )
  }

  const discount = promotionCode.amountOff
    ? CurrencyUtils.toCurrencyFormat(promotionCode.amountOff)
    : `${promotionCode.percentOff}%`

  if (variant === 'checkout') {
    return (
      <Alert
        severity="success"
        data-testid="promotion-code-alert"
        sx={checkoutAlertSx}
      >
        {t('You have an active offer with {{discount}} off waiting for you', {
          discount,
        })}
      </Alert>
    )
  }

  return <></>
}

export { PromotionCodeAlert }
